import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-06d36f88")

_pushScopeId("data-v-06d36f88")
const _hoisted_1 = { class: "scheme-info-box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { style: {"margin-left":"5px"} }, "专属睡眠改善方案", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { style: {"margin":"0 5px"} }, "-", -1)
const _hoisted_4 = { class: "zy-card product-info zy-info-block-item" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "product-info__title" }, [
  /*#__PURE__*/_createVNode("span", null, "调理产品")
], -1)
const _hoisted_6 = { class: "zy-card product-info zy-info-block-item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "product-info__title" }, [
  /*#__PURE__*/_createVNode("span", null, "用法用量")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("b", null, "【食用方法】", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "1、取10g膏滋（普通勺子 约1勺）放入杯中", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "2、加100-150ml温水化开，不能凉服（建议水温60度左右）", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "3、搅拌均匀，即可饮用", -1)
const _hoisted_14 = { class: "zy-card product-info zy-info-block-item" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "product-info__title" }, [
  /*#__PURE__*/_createVNode("span", null, "注意事项")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("b", null, "食用禁忌", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "产品含有蜂蜜，糖尿病患者、反酸烧心人群 不建议食用", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("b", null, "特别说明", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "产品不可替代药品", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("有疑问？咨询顾问")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("保存为图片")
const _hoisted_22 = { class: "wrapper" }
const _hoisted_23 = { class: "block" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("正在生成图片中，请稍等...")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_row = _resolveComponent("van-row")
  const _component_van_card = _resolveComponent("van-card")
  const _component_van_cell = _resolveComponent("van-cell")
  const _component_van_cell_group = _resolveComponent("van-cell-group")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_sticky = _resolveComponent("van-sticky")
  const _component_van_loading = _resolveComponent("van-loading")
  const _component_van_overlay = _resolveComponent("van-overlay")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, { class: "zy-header-info" }, {
      default: _withId(() => [
        _createVNode(_component_van_col, { span: "24" }, {
          default: _withId(() => [
            _createVNode(_component_van_row, null, {
              default: _withId(() => [
                _createVNode(_component_van_col, {
                  span: "24",
                  class: "yichu",
                  style: {"font-weight":"650"}
                }, {
                  default: _withId(() => [
                    _createVNode("span", {
                      textContent: _toDisplayString(_ctx.info['username'])
                    }, null, 8, ["textContent"]),
                    _hoisted_2
                  ]),
                  _: 1
                }),
                (_ctx.info['_schemeStartTimeMoment'] && _ctx.info['_schemeEndTimeMoment'])
                  ? (_openBlock(), _createBlock(_component_van_col, {
                      key: 0,
                      span: "24",
                      style: {"margin-top":"5px","color":"#808081","font-size":"0.8em"}
                    }, {
                      default: _withId(() => [
                        _createVNode("span", {
                          textContent: _toDisplayString(_ctx.info['_schemeStartTimeMoment'].format('YYYY/MM/DD'))
                        }, null, 8, ["textContent"]),
                        _hoisted_3,
                        _createVNode("span", {
                          textContent: _toDisplayString(_ctx.info['_schemeEndTimeMoment'].format('YYYY/MM/DD'))
                        }, null, 8, ["textContent"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_van_cell_group, { border: false }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.info['sleepProductList'], (item, index) => {
            return (_openBlock(), _createBlock(_component_van_cell, { key: index }, {
              title: _withId(() => [
                _createVNode(_component_van_card, {
                  num: item.productNum,
                  title: item.productName,
                  thumb: item.productPhoto
                }, {
                  desc: _withId(() => [
                    _createVNode(_component_van_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_van_col, {
                          span: "24",
                          textContent: _toDisplayString(item.needGram)
                        }, null, 8, ["textContent"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["num", "title", "thumb"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(_component_van_cell_group, { border: false }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.info['sleepProductList'], (item, index) => {
            return (_openBlock(), _createBlock(_component_van_cell, { key: index }, {
              title: _withId(() => [
                _createVNode(_component_van_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_van_col, { span: "12" }, {
                      default: _withId(() => [
                        _createVNode("b", {
                          textContent: _toDisplayString(item.productName)
                        }, null, 8, ["textContent"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_col, {
                      span: "24",
                      textContent: _toDisplayString(item.usageDosage)
                    }, null, 8, ["textContent"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_van_cell, null, {
            title: _withId(() => [
              _createVNode(_component_van_row, null, {
                default: _withId(() => [
                  _createVNode(_component_van_col, { span: "12" }, {
                    default: _withId(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "24" }, {
                    default: _withId(() => [
                      _hoisted_9,
                      _hoisted_10,
                      _hoisted_11,
                      _hoisted_12,
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_14, [
      _hoisted_15,
      _createVNode(_component_van_cell_group, { border: false }, {
        default: _withId(() => [
          _createVNode(_component_van_cell, null, {
            title: _withId(() => [
              _createVNode(_component_van_row, null, {
                default: _withId(() => [
                  _createVNode(_component_van_col, { span: "12" }, {
                    default: _withId(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "24" }, {
                    default: _withId(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "12" }, {
                    default: _withId(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "24" }, {
                    default: _withId(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_sticky, {
      "offset-bottom": 20,
      position: "bottom",
      "safe-area-inset-bottom": "",
      style: {"margin":"25px 0"},
      "data-html2canvas-ignore": ""
    }, {
      default: _withId(() => [
        _createVNode(_component_van_row, null, {
          default: _withId(() => [
            _createVNode(_component_van_col, {
              span: "10",
              offset: "1"
            }, {
              default: _withId(() => [
                _createVNode(_component_van_button, {
                  onClick: _ctx.toAdvisory,
                  type: "primary",
                  color: "rgb(116, 83, 213)",
                  round: false,
                  size: "normal",
                  block: ""
                }, {
                  default: _withId(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "10",
              offset: "2"
            }, {
              default: _withId(() => [
                _createVNode(_component_van_button, {
                  "data-html2canvas-ignore": "",
                  onClick: _ctx.saveAsImage,
                  type: "primary",
                  plain: "",
                  color: "",
                  round: false,
                  size: "normal",
                  block: ""
                }, {
                  default: _withId(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_overlay, { show: _ctx.saveAsImageLoading }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _createVNode(_component_van_loading, {
              "text-color": "#c9c9c9",
              color: "#0094ff",
              size: "24px"
            }, {
              default: _withId(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})